import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import { formatINR, formatDisplayDateOrDash } from "../../helpers";

const ExpenseDetailModal = ({ show, toggle, expense }) => {
    const { t } = useTranslation();

    if (!expense) return null;

    const formatExpenseDate = (date) => {
        try {
            return formatDisplayDateOrDash(date);
        } catch {
            return "—";
        }
    };

    const isBank = expense.paymentType === "bank";
    const typeColor = isBank ? "info" : "success";

    const detailFields = [
        {
            label: t("expenses.list.columns.categoryName"),
            value: (
                <span className="fw-semibold">
                    {expense.categoryName || "—"}
                </span>
            ),
        },
        {
            label: t("expenses.form.paymentType"),
            value: (
                <Badge bg={typeColor} className="text-uppercase px-2 py-1" style={{ fontSize: "12px" }}>
                    {isBank ? t("expenses.list.paymentType.bank") : t("expenses.list.paymentType.cash")}
                </Badge>
            ),
        },
        {
            label: t("expenses.list.columns.date"),
            value: formatExpenseDate(expense.date),
        },
    ];

    if (isBank) {
        detailFields.push({
            label: t("expenses.form.bank"),
            value: expense.bankName || "—",
        });
        detailFields.push({
            label: t("expenses.form.chequeNumber"),
            value: <span className="font-monospace">{expense.chequeNumber || "—"}</span>,
        });
    }

    if (expense.description) {
        detailFields.push({
            label: t("expenses.form.description"),
            value: expense.description,
        });
    }

    return (
        <Modal isOpen={show} toggle={toggle} centered size="md">
            <ModalHeader toggle={toggle} className="border-bottom">
                <div className="d-flex align-items-center gap-2">
                    <i className="bx bx-detail fs-4 text-primary"></i>
                    <span>{t("expenses.list.columns.id")} #{expense.id}</span>
                </div>
            </ModalHeader>
            <ModalBody className="p-0">
                {/* Amount highlight */}
                <div
                    className="text-center py-4"
                    style={{
                        background: isBank
                            ? "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)"
                            : "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
                    }}
                >
                    <p className="mb-1 text-muted small text-uppercase" style={{ letterSpacing: "1px" }}>
                        {t("expenses.form.amount")}
                    </p>
                    <h2 className="mb-0 fw-bold text-dark">
                        {formatINR(expense.amount)}
                    </h2>
                    <Badge bg={typeColor} className="text-uppercase mt-2 px-3 py-1" style={{ fontSize: "11px" }}>
                        {isBank ? t("expenses.list.paymentType.bank") : t("expenses.list.paymentType.cash")}
                    </Badge>
                </div>

                {/* Details list */}
                <div className="p-4">
                    {detailFields.map((field, index) => (
                        <Row
                            key={index}
                            className={`py-3 align-items-center ${index < detailFields.length - 1 ? "border-bottom" : ""}`}
                        >
                            <Col xs={5}>
                                <span className="text-muted small">{field.label}</span>
                            </Col>
                            <Col xs={7} className="text-end">
                                {field.value}
                            </Col>
                        </Row>
                    ))}
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ExpenseDetailModal;
